import { createAsyncActionTypes } from '../utils';

export const GET_NOTIFICATIONS = createAsyncActionTypes("GET_NOTIFICATIONS");
export const GET_UNREAD_NOTIFICATION_COUNT = createAsyncActionTypes("GET_UNREAD_NOTIFICATION_COUNT");
export const MARK_NOTIFICATION_READ = createAsyncActionTypes("MARK_NOTIFICATION_READ");
export const GET_NOTIFICATION_DETAIL = createAsyncActionTypes("GET_NOTIFICATION_DETAIL");
export const CLEAR_NOTIFICATION_DETAIL_RESPONSE = "CLEAR_NOTIFICATION_DETAIL_RESPONSE";
export const CLEAR_NOTIFICATION_READ_RESPONSE = "CLEAR_NOTIFICATION_READ_RESPONSE";